import { isEmpty } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import DownloadCSV from '../../../../components/DownloadCSV';
import { getCRSTransactionHistoryData } from '../../../../redux/actions/crs/crsRiskDetail';
import { TransactionHistoryModule } from '../../../../services/crs/apiModules/RiskDetailModules/transactionHistoryModule';
import { getCodesFromLC, getFormattedDate } from '../../../../services/util';
import {
  dateFormat_DD_MM_YY,
  dateTimeFormat
} from '../../../../util/GlobalConstant';
import { CRS_CONSTANTS } from '../../../constants/crsContants';
import CRSTableContainer from '../CRSProfileTables/CRSTableContainer';
import { getCSVHeaders, processDataFromProps } from '../riskDetailUtil';
import { transactionMappingBackup } from './constants';

const { GET_DATA } = CRS_CONSTANTS;

/**
 * AssocTransaction Section component
 */
export class AssocTransaction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChevronClicked: false,
      dateRange: {
        startDate: moment(
          props.alertDate ? new Date(props.alertDate) : new Date()
        )
          .subtract(30, 'days')
          .add(1, 'days'),
        endDate: moment(
          props.alertDate ? new Date(props.alertDate) : new Date()
        ),
        activeRangeNo: 2
      },
      currentPage: 0,
      triggered: false,
      transactionData: [],
      csvDownloadClicked: false
    };
  }

  async componentDidMount() {
    const { dateRange } = this.state;
    const { startDate, endDate } = dateRange;
    this.props.dispatch(
      getCRSTransactionHistoryData(
        {
          customerKey: this.props.customerKey,
          from: getFormattedDate(startDate, dateFormat_DD_MM_YY),
          to: getFormattedDate(endDate, dateFormat_DD_MM_YY),
          offset: 0,
          limit: 10
        },
        GET_DATA
      )
    );
    let mapping = await getCodesFromLC('transactionProductMapping');
    if (isEmpty(mapping)) {
      mapping = transactionMappingBackup;
    }
    this.setState({ transactionProductMapping: mapping });
  }

  onChevronClick = () => {
    this.setState({ isChevronClicked: !this.state.isChevronClicked });
  };

  onDateChange = (start, end, rangeNo) => {
    const newDateRange = {
      startDate: start,
      endDate: end,
      activeRangeNo: rangeNo
    };
    this.setState(
      {
        ...this.state,
        dateRange: newDateRange,
        currentPage: 0
      },
      () => {
        const {
          dateRange: { startDate, endDate }
        } = this.state;
        this.props.dispatch(
          getCRSTransactionHistoryData(
            {
              customerKey: this.props.customerKey,
              from: getFormattedDate(startDate, dateFormat_DD_MM_YY),
              to: getFormattedDate(endDate, dateFormat_DD_MM_YY),
              offset: 0,
              limit: 10
            },
            GET_DATA
          )
        );
      }
    );
  };

  onScrollToLoad = async () => {
    const {
      currentPage,
      dateRange: { startDate, endDate }
    } = this.state;
    this.setState({
      ...this.state,
      currentPage: currentPage + 1
    });

    await this.onTransactionHistoryScrollToLoad(
      startDate,
      endDate,
      (currentPage + 1) * 10
    );
  };

  onPaginationChange = async (page, pageSize) => {
    const {
      dateRange: { startDate, endDate },
      currentPage
    } = this.state;
    this.setState(
      {
        ...this.state,
        currentPage: page - 1
      },
      () => {
        this.onTransactionHistoryScrollToLoad(
          startDate,
          endDate,
          (page - 1) * pageSize
        );
      }
    );
  };

  onTransactionHistoryDownload = async (customerKey) => {
    this.setState({ transactionData: [] });
    const {
      dateRange: { startDate, endDate }
    } = this.state;
    const { CRS_BASE_URL, HTTP_HEADERS } = CRS_CONSTANTS;
    const transactionHistoryModule = new TransactionHistoryModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    const tranData = await transactionHistoryModule.fetchTransactionHistory({
      customerKey,
      from: getFormattedDate(startDate, dateFormat_DD_MM_YY),
      to: getFormattedDate(endDate, dateFormat_DD_MM_YY),
      offset: 0,
      limit: 5000
    });
    const { associated_transactions } = tranData;
    if (associated_transactions.length === 0) {
      this.setState({ transactionData: [{}] });
      return false;
    }
    this.setState({ transactionData: associated_transactions });
  };

  /**
   * onTransactionHistoryScrollToLoad
   * @param start
   * @param end
   * @param offset
   */
  onTransactionHistoryScrollToLoad = async (start, end, offset) => {
    this.props.dispatch(
      getCRSTransactionHistoryData(
        {
          customerKey: this.props.customerKey,
          from: getFormattedDate(start, dateFormat_DD_MM_YY),
          to: getFormattedDate(end, dateFormat_DD_MM_YY),
          offset: offset,
          limit: 10,
          isScrolled: true
        },
        GET_DATA
      )
    );
  };

  getFileName = () => {
    const dateObj = new Date();
    const timestamp = dateObj.getTime();
    return `Transactions__${
      this.props.customerKey
    }--${this.state.dateRange.startDate.format(
      'DDMMYYYY'
    )}-to-${this.state.dateRange.endDate.format('DDMMYYYY')}__${timestamp}.csv`;
  };

  getParamsFromResponse = () => {
    const { crsRiskDetailData, customerKey } = this.props;
    const { transactionHistoryResponse } =
      processDataFromProps(crsRiskDetailData);
    const {
      data,
      data: { customerId, isScrolled } = {},
      fetched,
      isFetching
    } = transactionHistoryResponse || {};
    let rows = data ? data.associated_transactions : [];
    let count = data?.count ? data.count : 0;

    return {
      customerKey,
      rows,
      data,
      customerID: customerId,
      isScrolled,
      fetched,
      isFetching,
      count
    };
  };

  render() {
    const { dateRange, transactionData, isChevronClicked, currentPage } =
      this.state;
    const chevronClassName = isChevronClicked
      ? 'fa fa-angle-up'
      : 'fa fa-angle-down';
    const { rows, isFetching, count } = this.getParamsFromResponse();

    return (
      <CRSTableContainer
        header="Transaction Details"
        GSConfig={this.props.GSConfig}
        data={rows}
        onDateChange={this.onDateChange}
        loadMore={() => {}}
        loading={isFetching}
        hasMore={false}
        dateRange={dateRange}
        dataMapping={{
          isCredit: (row) =>
            row.amount == '' || row.amount === '-'
              ? ''
              : row.isCredit == null || row.isCredit == undefined
              ? '-'
              : row.isCredit
              ? 'CR'
              : 'DR',
          transactionDate: (row) =>
            row.transactionDate
              ? moment
                  .utc(row.transactionDate, [dateTimeFormat])
                  .local()
                  .format('DD/MM/YYYY')
              : '-'
        }}
        rowKey="id"
        actions={
          <DownloadCSV
            csvData={transactionData}
            csvHeaders={getCSVHeaders(this.props.GSConfig?.widgetConfig)}
            fileName={this.getFileName()}
            onDownloadClick={() => {
              this.onTransactionHistoryDownload(this.props.customerKey);
            }}
            disabled={!rows?.length}
          />
        }
        pagination={{
          total: count,
          current: currentPage + 1,
          pageSize: 10,
          onChange: this.onPaginationChange,
          showTotal: (total) => `${total} Records`,
          showSizeChanger: false
        }}
      />
    );
  }
}

AssocTransaction.propTypes = {
  customerKey: PropTypes.string,
  GSConfig: PropTypes.object,
  crsRiskDetailData: PropTypes.object,
  dispatch: PropTypes.func,
  alertDate: PropTypes.string
};

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{crsRiskDetailData: crsRiskDetailReducer}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    crsRiskDetailData: state.crsRiskDetailReducer
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *, navigateTo: navigateTo}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

/**
 * connect function for CRSRiskDetail page
 */
export default connect(mapStateToProps, mapDispatchToProps)(AssocTransaction);
